import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, Signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

/** Punti di rottura della struttura (contracts/ui-shell-navigation.md). */
export const DESKTOP_QUERY = '(min-width: 1024px)';
export const MOBILE_QUERY = '(max-width: 767.98px)';

/**
 * Larghezza della finestra: da 1024 px la barra laterale è fissa, sotto è un pannello apribile;
 * sotto i 768 px compare la barra in basso.
 */
@Injectable({ providedIn: 'root' })
export class ViewportService {
  private readonly observer = inject(BreakpointObserver);

  readonly isDesktop: Signal<boolean> = this.watch(DESKTOP_QUERY);
  readonly isMobile: Signal<boolean> = this.watch(MOBILE_QUERY);

  private watch(query: string): Signal<boolean> {
    return toSignal(this.observer.observe(query).pipe(map((state) => state.matches)), {
      initialValue: this.observer.isMatched(query),
    });
  }
}
